module.exports = __webpack_public_path__ + "static/media/filter_4_white_18dp.0d87129a.svg";